export const CURRENCIES = {
    USD: 'USD',
    GBP: 'GBP',
    JPY: 'JPY',
    EUR: 'EUR',
    CAD: 'CAD',
    CHF: 'CHF',
    SGD: 'SGD',
};
export const symbols = {
    [CURRENCIES.USD]: '$',
    [CURRENCIES.GBP]: '£',
    [CURRENCIES.EUR]: '€',
    [CURRENCIES.JPY]: '¥',
    [CURRENCIES.CHF]: '₣',
    [CURRENCIES.CAD]: '$',
    [CURRENCIES.SGD]: 'S$',
};
